import React, { useMemo } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { StatusManager } from 'common/components/StatusManager';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { UIStatus } from 'UI/constants/status';

import { NEW_JOB_ORDER_ENDPOINTS } from '../../constants';
import { NewJobOrder } from '../NewJobOrderForm';

import { formatDraft } from './newJobOrderDataLoader.utils';

export const NewJobOrderDataLoader = ({
  deletedDraftId,
  draftId,
  history,
  location,
  onDraftSaved,
  onResetForm
}) => {
  const endpoint = draftId ? NEW_JOB_ORDER_ENDPOINTS.draft.replace(':id', draftId) : null;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT,
    apiVersion: 1,
    initialStatus: endpoint ? UIStatus.Loading : UIStatus.Default
  });

  const draft = useMemo(
    () => (state.status === UIStatus.Success ? formatDraft(draftId, state.results) : null),
    [draftId, state.results, state.status]
  );

  return (
    <StatusManager
      status={state.status}
      slots={{
        Error: (
          <EmptyPlaceholder title={strings.shared.ui.unknownError.title} subtitle={state.error} />
        ),
        Loading: <LinearProgress />,
        Default: (
          <NewJobOrder
            databaseDraft={null}
            deletedDraftId={deletedDraftId}
            history={history}
            location={location}
            onDraftSaved={onDraftSaved}
            onResetForm={onResetForm}
          />
        )
      }}
    >
      <NewJobOrder
        databaseDraft={draft}
        deletedDraftId={deletedDraftId}
        history={history}
        location={location}
        onDraftSaved={onDraftSaved}
        onResetForm={onResetForm}
      />
    </StatusManager>
  );
};
